import { createRouter, createWebHistory } from "vue-router";
import dashboard from "@/router/dashboard/dashboard";
import trainingCourseAdmin from "@/router/studea-manager/studea-manager";
import globalAdmin from "@/router/admin/admin";
import login from "@/router/login/login";
import error from "@/router/error/error";
import profile from "@/router/profile/profile";
import { accessManager } from "@/services/security/access-manager";
import sharedDocument from "@/router/shared-document/shared-document";
import trainingCourseDuplicateView from "@/router/duplicate/duplicate";
import training from "@/router/training/training";
import indentSheet from "@/router/indent-sheet/indent-sheet";
import driverLicenceList from "@/router/driver-licence/driver-licence";
import registration from "@/router/registration/registration";
import releaseNotes from "@/router/release-note/release-note";
import redirectedRoute from "@/router/redirected-route/redirected-route";
import gradebook from "@/router/gradebook/gradebook";
import userActivateRoute from "@/router/user/user";
import { useErrorStore } from "@/store/error/error";
import downloadRoute from "@/router/download/download-route";
import apprentice from "@/router/apprentice/apprentice";
import institution from "@/router/institution/institution";
import company from "@/router/company/company";
import matching from "@/router/matching/matching";
import landing from "@/router/landing/landing";
import * as Sentry from "@sentry/vue";
import { analyticsManager } from "@/services/analytics/analytics-manager";
import { guardHistory } from "@/router/history-guard";

const CHUNK_RELOAD_STORAGE_KEY = "studea-chunk-reload";

const pathsToRedirect = [
  "inscription",
  "manage/inscription",
  "les-inscriptions-3",
  "gestion-globale-des-inscriptions",
  "recrutement",
  "registration-document",
  "piloting",
  "sl",
];

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  //Redirect inscription V3 to V2
  {
    path: `/:prefix(${pathsToRedirect.join("|")})/:catchAll(.*)*`,
    redirect: (to) => {
      const fullUrl = `${window.location.origin}${to.fullPath}`;
      return {
        path: "/redirected-route",
        query: { from: fullUrl },
      };
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/error",
  },
  dashboard,
  trainingCourseAdmin,
  globalAdmin,
  login,
  error,
  profile,
  sharedDocument,
  trainingCourseDuplicateView,
  indentSheet,
  training,
  driverLicenceList,
  registration,
  releaseNotes,
  redirectedRoute,
  gradebook,
  downloadRoute,
  userActivateRoute,
  apprentice,
  company,
  institution,
  matching,
  landing,
];

guardHistory();

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  // Attach transaction to route meta
  to.meta.sentrySpan = Sentry.startInactiveSpan({
    name: to.name,
    op: "navigation",
    tags: {
      from: from.name,
      to: to.name,
    },
  });

  setTimeout(() => {
    useErrorStore().init();
  }, 5);
  accessManager.checkRoleAccess(to, from).then((res) => {
    if (res) {
      next();
    }
  });
});

router.afterEach((to, from, failure) => {
  const span = to.meta.sentrySpan;
  if (span) {
    span.end();
  }

  sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY);
  analyticsManager.trackPageView(to, from, failure);
});

const CHUNK_LOAD_ERROR_PATTERN =
  /Loading( CSS)? chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i;

router.onError((error, to) => {
  if (CHUNK_LOAD_ERROR_PATTERN.test(error.message) && !sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, "1");
    window.location.href = to.fullPath;
  }
});

export default router;
